<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title
        @back="$router.replace({ name: 'reverse.logistics' })"
        :content="$t('logistica-reversa')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-card class="box-card">
          <el-row :gutter="5">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-if="user.type !== '2' && user.type !== '5'">
              <el-form-item class="no-margin-bottom" :label="$t('cliente')">
                <CustomerList v-model="ruleForm.customer" :current="customerCurrent" @input="ruleForm.department = ''" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item class="no-margin-bottom" :label="$t('departamento')">
                <DepartmentList v-model="ruleForm.department" :customer="ruleForm.customer" />
              </el-form-item>
            </el-col>
            <!-- Etiqueta Original (TASK-1808): bipar a etiqueta do envio preenche remetente e destinatário -->
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item class="no-margin-bottom" label="Etiqueta original">
                <el-input
                  v-model="tag"
                  placeholder="Bipe ou digite a etiqueta do envio"
                  clearable
                  @keyup.enter.native="fetchRecords"
                >
                  <el-button slot="append" icon="el-icon-search" @click="fetchRecords"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t("dados-remetente") }}</span>
          </div>
          <div>
            <el-row :gutter="5">
              <el-col :xs="14" :sm="6" :md="6" :lg="5" :xl="5">
                <el-form-item :label="$t('nome-contato')" prop="contact">
                  <el-input maxlength="200" v-model="ruleForm.contact"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="3" :xl="3">
                <el-form-item :label="$t('cpf-cnpj')" prop="type" class="is-required">
                  <el-input v-model="ruleForm.federalid" v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('cep')" prop="cep">
                  <el-input maxlength="9" v-model="ruleForm.cep" v-mask="'#####-###'" @blur="zip(0)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('endereco')" prop="address">
                  <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('numero')" prop="number">
                  <el-input type="number" maxlength="6" v-model="ruleForm.number" v-mask="'######'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('bairro')" prop="neighborhood">
                  <el-input v-model="ruleForm.neighborhood"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('cidade')" prop="city">
                  <el-input v-model="ruleForm.city"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('estado')" prop="state">
                  <el-input v-model="ruleForm.state"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="14" :sm="6" :md="6" :lg="12" :xl="12">
                <el-form-item :label="$t('complemento')" prop="extent">
                  <el-input v-model="ruleForm.extent"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="14" :sm="6" :md="6" :lg="12" :xl="12">
                <el-form-item :label="$t('referencia')" prop="extent">
                  <el-input v-model="ruleForm.reference"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="6" :md="6" :lg="5" :xl="5">
                <el-form-item :label="$t('celular')" prop="cellphone" class="is-required">
                  <el-input v-model="ruleForm.cellphone" v-mask="['(##) #####-####', '(##) #####-####']"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="5" :xl="5">
                <el-form-item :label="$t('telefone')" prop="phone" v-mask="'(##) #####-####'">
                  <el-input v-model="ruleForm.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="8" :xl="8">
                <el-form-item :label="$t('email')" prop="mail" class="is-required">
                  <el-input v-model="ruleForm.mail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t("dados-objeto") }}</span>
          </div>
          <div>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
                <el-form-item :label="$t('peso')" prop="total" class="is-required">
                  <el-input-number
                    id="weight"
                    v-model="ruleForm.weight"
                    :controls="false"
                    :precision="0"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
                <el-form-item :label="$t('valor-declarado')" prop="value" class="is-required">
                  <el-input-number
                    id="declaredvalue1"
                    v-model="ruleForm.value"
                    :controls="false"
                    :precision="2"
                    :max="declaredvalue.max"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
                <el-form-item :label="$t('controle-cliente')" prop="control">
                  <el-input v-model="ruleForm.control"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="5" :xl="5">
                <el-form-item :label="$t('checklist')" prop="checklist">
                  <el-select v-model="ruleForm.checklist" placeholder="Select">
                    <el-option label="Sem checklist" value=""></el-option>
                    <el-option label="Celular" :value="2"></el-option>
                    <el-option label="Eletronico" :value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('conteudo-encomendas')" prop="content">
                  <el-input v-model="ruleForm.content" type="text"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('quantidade')" prop="content">
                  <el-input v-model="ruleForm.quantity" type="number"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('valor')" prop="content">
                  <el-input v-model="ruleForm.value" type="number"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <el-switch
                  active-text="AUTORIZAR A EMISSÃO DE AVISO DE RECEBIMENTO"
                  v-model="ruleForm.warning"
                ></el-switch>
                <br />
                <el-switch
                  active-text="AUTORIZAR A AQUISIÇÃO DA EMBALAGEM NA POSTAGEM"
                  v-model="ruleForm.register"
                ></el-switch>
                <br />
                <el-switch
                  active-text="AUTORIZAR EMISSÃO DE A.P. ARTIGOS PERIGOSOS ANAC"
                  v-model="ruleForm.ap"
                ></el-switch>
                <ArtigosPerigososPopover style="display: inline-block; vertical-align: middle;" />
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="ruleForm.register">
              <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('embalagem')" prop="packing">
                  <ReverseLogisticsPackage v-model="ruleForm.packing" @selected="packing" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t("local-entrega-destinatario") }}</span>
          </div>
          <div>
            <el-alert
              v-if="destinyLocked"
              type="info"
              :closable="false"
              show-icon
              title="Reversa Consolidada: o destinatário é o endereço do cadastro do cliente e não pode ser alterado."
              style="margin-bottom: 8px"
            ></el-alert>
            <el-row :gutter="5">
              <el-col :xs="14" :sm="6" :md="6" :lg="5" :xl="5">
                <el-form-item :label="$t('nome-contato')" prop="cep">
                  <el-input maxlength="200" v-model="ruleForm.destiny.contact"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('cep')" prop="cep">
                  <el-input maxlength="9" v-model="ruleForm.destiny.cep" v-mask="'#####-###'" @blur="zip(1)" :disabled="destinyLocked"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('endereco')" prop="address">
                  <el-input v-model="ruleForm.destiny.address" :disabled="destinyLocked"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('numero')" prop="number">
                  <el-input type="number" maxlength="6" v-model="ruleForm.destiny.number" v-mask="'######'" :disabled="destinyLocked"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('bairro')" prop="neighborhood">
                  <el-input v-model="ruleForm.destiny.neighborhood" :disabled="destinyLocked"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('cidade')" prop="city">
                  <el-input v-model="ruleForm.destiny.city" :disabled="destinyLocked"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
                <el-form-item :label="$t('estado')" prop="state">
                  <el-input v-model="ruleForm.destiny.state" :disabled="destinyLocked"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="14" :sm="6" :md="6" :lg="12" :xl="12">
                <el-form-item :label="$t('complemento')" prop="extent">
                  <el-input v-model="ruleForm.destiny.extent" :disabled="destinyLocked"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="14" :sm="6" :md="6" :lg="12" :xl="12">
                <el-form-item :label="$t('referencia')" prop="extent">
                  <el-input v-model="ruleForm.destiny.complement"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="10" :md="10" :lg="4" :xl="4">
                <el-form-item :label="$t('telefone')" prop="phone">
                  <el-input v-model="ruleForm.destiny.phone" v-mask="['(##) #####-####', '(##) #####-####']"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="14" :md="14" :lg="8" :xl="8">
                <el-form-item :label="$t('email')" prop="mail">
                  <el-input v-model="ruleForm.destiny.mail"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="20">
                <el-form-item prop="typeContent">
                  <el-radio v-model="ruleForm.typeContent" label="1" value="1">Com nota fiscal</el-radio
                  >
                  <el-radio v-model="ruleForm.typeContent" label="2"  value="2"
                    >Com DC-E</el-radio
                  >
                  <el-radio v-model="ruleForm.typeContent" label="3"  value="3"
                    >Emitir DC-E</el-radio
                  >
                  <el-radio v-model="ruleForm.typeContent" label="4"  value="4"
                    >Enviar NF-E posteriormente</el-radio
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="ruleForm.typeContent === '1'">
              <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item label="Chave NFE" prop="nfeKey">
                  <el-input
                    v-model="ruleForm.nfeKey"
                    placeholder="Digite a chave NFE"
                    maxlength="44"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item label="Número da Nota" prop="nfeNumber">
                  <el-input
                    v-model="ruleForm.nfeNumber"
                    placeholder="Digite o número da nota"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <el-form-item label="Número de Série" prop="nfeSerie">
                  <el-input
                    v-model="ruleForm.nfeSerie"
                    placeholder="Digite o número de série"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="ruleForm.typeContent === '2'">
              <el-col :xs="24" :sm="20" :md="12" :lg="10" :xl="8">
                <el-form-item label="Código DC-E" prop="dceId">
                  <el-input
                    v-model="ruleForm.dceId"
                    placeholder="Digite o código da DC-E"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="ruleForm.typeContent === '3'">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-alert 
                  class="fs-14"
                  type="error" 
                  title="Ao emitir a DC-E você deverá informar a Declaração de Conteúdo no botão abaixo. A DC-E é um documento que substitui a nota fiscal e deve conter as informações da descrição do conteúdo, valor declarado e outras informações relevantes para a postagem."
                  :closable="false"
                ></el-alert>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="ruleForm.typeContent === '4'">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-alert 
                  class="fs-14"
                  type="error" 
                  title="Nesse caso a pre-posatagem ficará pendente e você poderá enviar a chave NF-E ou DC-E posteriormente."
                  :closable="false"
                ></el-alert>
              </el-col>
            </el-row>

          </div>
        </el-card>
        <!-- Serviços em cards depois de remetente e destinatário (TASK-1808) -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t("servico") }}</span>
          </div>
          <el-alert
            v-if="!services.length"
            :closable="false"
            type="info"
            :title="servicesKey ? 'Nenhum serviço de reversa habilitado para este cliente.' : 'Preencha o CEP e a UF do remetente e do destinatário para ver os serviços.'"
          ></el-alert>
          <div v-if="consolidatedOnly" class="reverse-consolidated-alert">
            <i class="el-icon-info"></i>
            <div>
              <b>Este remetente é atendido pela Reversa Consolidada.</b>
              <p>
                Para remetentes deste estado, a logística reversa é feita somente pela Reversa Consolidada. As demais
                reversas continuam disponíveis para remetentes de outros estados.
              </p>
            </div>
          </div>
          <el-row :gutter="5" style="text-align: center">
            <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="3" v-for="record of services" :key="record.code">
              <el-card
                shadow="always"
                style="min-height: 200px"
                :body-style="{ 'background-color': record.code === ruleForm.service ? '#f4f4f5' : '' }"
              >
                <img v-if="record.image" :src="record.image" width="100%" height="80px" class="image" />
                <div class="reverse-card-name">{{ record.name }}</div>
                <template v-if="record.available">
                  <div class="reverse-card-value">
                    {{ record.value | currency("R$ ", 2, { thousandsSeparator: ".", decimalSeparator: "," }) }}
                  </div>
                  <el-tag v-if="deadlineLabel(record)" type="info" size="small">{{ deadlineLabel(record) }}</el-tag>
                </template>
                <el-alert
                  v-else
                  :description="record.description || 'Serviço indisponível para o trecho informado.'"
                  type="warning"
                  :closable="false"
                ></el-alert>
                <el-button
                  :type="record.code === ruleForm.service ? 'success' : 'primary'"
                  size="mini"
                  style="margin-top: 3px; width: 100%"
                  @click="selected(record.code)"
                  >{{ record.code === ruleForm.service ? "Selecionado" : "Selecionar" }}</el-button
                >
              </el-card>
            </el-col>
          </el-row>
          <div class="bottom clearfix text-center">
            <el-button type="primary" class="button" @click="add">Adicionar</el-button>
            <el-button type="warning" class="button" @click="$router.replace({ name: 'reverse.logistics' })"
              >Voltar</el-button
            >
          </div>
        </el-card>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { ReverseLogisticsService } from "@/services/customers/reverse.logistics.services";
import { UserService } from "@/services/users/user.services";
import { CnpjHelpers } from "@/xpost/helpers/cnpj";
import { CpfHelpers } from "@/xpost/helpers/cpf";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import DepartmentList from "@/xpost/views/register/department/DepartmentList";
import ZipMixins from "../../../mixins/zipcode";
import ReverseLogisticsPackage from "./ReverseLogisticsPackage";
import { ServicesService } from "@/services/customers/services.services";
import ArtigosPerigososPopover from "@/components/ArtigosPerigososPopover";
import { formatDeadlineDays } from "@/utils/shipping-deadline";
import { customerForOriginalTag, nfeFormPatch, nfeFormReset } from "@/utils/reverse-original.mjs";
import { isConsolidatedOnly, reverseCardsToShow } from "@/utils/reverse-cards.mjs";

export default {
  name: "ReverseLogistics",
  mixins: [ZipMixins],
  components: {
    CustomerList,
    DepartmentList,
    ReverseLogisticsPackage,
    ArtigosPerigososPopover,
  },
  computed: {
    // O seletor de cliente não lê o v-model: sem isto ele não mostra o cliente que a tela define sozinha.
    customerCurrent() {
      return this.ruleForm.customer ? [this.ruleForm.customer] : [];
    },
    // Aviso acima dos cards quando só a Reversa Consolidada é exibida.
    consolidatedOnly() {
      return isConsolidatedOnly(this.services);
    },
    // Serviços dependem do cliente e do par remetente/destinatário (Reversa Consolidada).
    servicesKey() {
      const source = (this.ruleForm.cep || "").replace(/\D/g, "");
      const destiny = (this.ruleForm.destiny.cep || "").replace(/\D/g, "");
      const sourceState = (this.ruleForm.state || "").trim().toUpperCase();
      const state = (this.ruleForm.destiny.state || "").trim().toUpperCase();
      if (source.length !== 8 || sourceState.length !== 2 || destiny.length !== 8 || state.length !== 2) return "";
      const selectsCustomer = this.user.type !== "2" && this.user.type !== "5";
      if (selectsCustomer && !this.ruleForm.customer) return "";
      // Peso, valor declarado, AR e artigos perigosos entram na chave: mudam a cotação dos cards.
      return [this.ruleForm.customer, source, sourceState, destiny, state, +this.ruleForm.weight || 0, +this.ruleForm.value || 0, !!this.ruleForm.warning, !!this.ruleForm.ap].join("|");
    },
  },
  watch: {
    servicesKey() {
      this.loadServices();
    },
  },
  methods: {
    loadServices() {
      const vm = this;
      vm.services = [];
      const key = vm.servicesKey;
      if (!key) return;
      const [customer, sourceZipcode, sourceState, destinyZipcode, destinyState, weight, valuedeclared, warning, ap] = key.split("|");
      ReverseLogisticsService.services({
        customer: customer || undefined, sourceZipcode, sourceState, destinyZipcode, destinyState,
        weight: +weight, valuedeclared: +valuedeclared, warning: warning === "true", ap: ap === "true",
      })
        .then((response) => {
          // Resposta de um endereço/peso que já mudou: ignora (as chamadas podem voltar fora de ordem).
          if (key !== vm.servicesKey) return;
          // Com a Reversa Consolidada disponível, as reversas dos Correios não aparecem.
          vm.services = reverseCardsToShow(response);
          if (!vm.services.some((x) => x.code === vm.ruleForm.service)) {
            vm.ruleForm.service = "";
            vm.destinyLocked = false;
          } else if (vm.destinyLocked) {
            // Etiqueta original ou outro preenchimento não troca o destinatário da consolidada.
            vm.selected(vm.ruleForm.service);
          }
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        });
    },
    deadlineLabel(record) {
      return formatDeadlineDays(record, record.deadlineDays);
    },
    zip(type) {
      const vm = this;
      if (type === 1) {
        vm.zipcode(vm.ruleForm.destiny);
      } else {
        vm.zipcode(vm.ruleForm);
      }
    },
    packing(id) {
      this.ruleForm.packing = id;
    },
    selected(current) {
      const vm = this;
      vm.ruleForm.service = current;
      // Reversa Consolidada: destinatário = endereço do cadastro do cliente, sem edição.
      const record = vm.services.find((x) => x.code === current);
      vm.destinyLocked = !!(record && record.consolidated && record.destiny);
      if (vm.destinyLocked) {
        const d = record.destiny;
        Object.assign(vm.ruleForm.destiny, {
          cep: d.zipcode ? `${d.zipcode.slice(0, 5)}-${d.zipcode.slice(5)}` : "",
          address: d.address,
          number: d.number,
          neighborhood: d.neighborhood,
          city: d.city,
          state: d.state,
          extent: d.extent,
        });
      }
      ServicesService.code(current)
        .then((response) => {
          vm.declaredvalue.min = +response.valuemin;
          vm.declaredvalue.max = +response.valuemax;
        })
        .catch(() => {});
    },
    add() {
      const vm = this;
      if (!vm.ruleForm.service) {
        return vm.$message({ type: "error", message: "Selecione um serviço!" });
      }
      const loading = vm.$loading(vm.$options.loading);
      ReverseLogisticsService.add(vm.ruleForm)
        .then((response) => {
          this.$message({
            type: "success",
            message: "Logistica Reversa adicionada com sucesso!",
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      UserService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    // Documento do envio original: nota fiscal (chave, número, série, valor) ou, se o envio usou
    // declaração de conteúdo, "Emitir DC-E" com conteúdo, quantidade e valor (nunca o código da DC-E da
    // ida). Etiqueta sem documento limpa só o que uma etiqueta anterior tinha preenchido (não apaga o
    // que o usuário digitou).
    applyOriginalNfe(nfe) {
      const vm = this;
      const patch = nfeFormPatch(nfe);
      Object.assign(vm.ruleForm, nfeFormReset(vm.originalNfePatch, patch, vm.ruleForm), patch || {});
      vm.originalNfePatch = patch;
    },
    // Envio original: o destinatário vira o remetente da reversa e o remetente (cliente) o destinatário.
    fetchRecords() {
      const vm = this;
      const tag = (vm.tag || "").trim();
      if (!tag) return;
      ReverseLogisticsService.original(tag)
        .then((response) => {
          if (vm.user.type !== "2" && vm.user.type !== "5") {
            // Cliente já escolhido antes da etiqueta vale mais que o dono da etiqueta: os serviços
            // (e a Reversa Consolidada) são os do cliente escolhido.
            const { customer, mismatch } = customerForOriginalTag(vm.ruleForm.customer, response.customer);
            vm.ruleForm.customer = customer;
            if (mismatch) {
              vm.$message({ type: "info", message: "A etiqueta é de outro cliente: o cliente selecionado foi mantido." });
            }
          }
          Object.assign(vm.ruleForm, response.sender);
          Object.assign(vm.ruleForm.destiny, response.destiny);
          vm.applyOriginalNfe(response.nfe);
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            duration: 5000,
            message: error,
          });
        });
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (response.type == "2") {
          vm.ruleForm.customer = response.customers.id;
        }
        if (this.$route.params.tag) {
          vm.tag = this.$route.params.tag;
          vm.fetchRecords();
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    var checkFederalid = (rule, value, callback) => {
      if (value.length == 14) {
        CpfHelpers.checkCpf(rule, value, callback);
      } else if (value.length == 18) {
        CnpjHelpers.checkCnpj(rule, value, callback);
      }
      return callback();
    };
    return {
      tag: "",
      originalNfePatch: null,
      services: [],
      destinyLocked: false,
      user: { type: "2" },
      declaredvalue: {
        min: 0,
        max: 34000,
      },
      ruleForm: {
        service: "",
        customer: "",
        department: "",
        cep: "",
        contact: "",
        federalid: "",
        packing: "",
        address: "",
        neighborhood: "",
        number: "",
        city: "",
        state: "",
        requestType: "A",
        extent: "",
        reference: "",
        cellphone: "",
        phone: "",
        mail: "",
        package: "",
        content: "",
        quantity: 1,
        valuedeclared: 1,
        qtypackage: 0,
        type: "",
        objects: 1,
        value: 0,
        total: 0,
        authorization: "",
        control: "",
        checklist: "",
        weight: 1,
        typeContent: "1",
        nfeKey: "",
        nfeNumber: "",
        nfeSerie: "",
        dceId: "",        
        warning: false,
        register: false,
        ap: false,
        destiny: {
          cep: "",
          contact: "",
          address: "",
          neighborhood: "",
          number: "",
          city: "",
          state: "",
          extent: "",
          complement: "",
          mail: "",
          phone: "",
        },
      },
      rules: {
        cep: [
          {
            required: true,
            message: i18n.tc("cep-obrigatorio"),
            trigger: "blur",
          },
        ],
        contact: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        value: [
          {
            required: true,
            message: i18n.tc("valor-obrigatorio"),
            trigger: "blur",
          },
        ],
        federalid: {
          validator: checkFederalid,
          trigger: "blur",
        },
      },
    };
  },
};
</script>
<style scoped>
.reverse-card-name {
  margin: 4px 0;
  font-size: 13px;
  line-height: 1.3;
}
.reverse-card-value {
  color: #67c23a;
  font-weight: 600;
  margin-bottom: 3px;
}
.reverse-consolidated-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  padding: 9px 14px;
  border-radius: 4px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 13px;
}
.reverse-consolidated-alert i {
  font-size: 16px;
  margin-top: 1px;
}
.reverse-consolidated-alert p {
  margin: 3px 0 0;
  font-size: 12px;
  line-height: 1.45;
}
</style>
